import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export const NAMESPACES = [
  'common',
  'cockpit',
  'plaene',
  'belegung',
  'personal',
  'sachkosten',
  'finanzierung',
  'betreuungspreise',
  'traeger',
  'einrichtung',
  'vergleich',
  'admin',
  'errors',
  'legal',
] as const;

export type Namespace = (typeof NAMESPACES)[number];

export const SUPPORTED_LANGUAGES = ['de', 'en', 'tr', 'ar', 'uk', 'ru'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    lng: 'de',
    fallbackLng: 'de',
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    ns: NAMESPACES as unknown as string[],
    defaultNS: 'common',
    // Unsere JSON-Bundles nutzen flache Keys mit Punkt (z. B. "actions.delete"),
    // keine nested objects → keySeparator deaktivieren, damit i18next den Key
    // 1:1 nachschlägt. nsSeparator bleibt ":".
    keySeparator: false,
    nsSeparator: ':',
    interpolation: {
      escapeValue: false,
    },
    backend: {
      // Bezieht JSON-Defaults + DB-Overrides aus ``ref_i18n_override``
      // gemergt vom Backend. Statische Frontend-JSONs bleiben als
      // DeepL-Pipeline-Output erhalten und werden im Backend-Container
      // als Default-Quelle eingebunden.
      loadPath: '/api/v1/i18n/{{lng}}/{{ns}}.json',
    },
    react: {
      useSuspense: true,
    },
    returnNull: false,
  });

export default i18n;
